import axiosPost from '../axiosPost';
import { AxiosPostBody } from '../../../types/AxiosPost';
import { UserCredentialsType } from '../../../types/types';

type Args = UserCredentialsType & {
    "merchantId": number
    "fechaDesde": string
    "fechaHasta": string
    "metodoDePago": string
    "canal": string
    "dni": string
    "comprobante": string
    "estado": string
};

export const MWVentaGet = async (arg: Args) => {
    const body: AxiosPostBody = {
        "service": "MWVentaGet",
        "params": {
            "merchantId": arg.merchantId,
            "fechaDesde": arg.fechaDesde,
            "fechaHasta": arg.fechaHasta,
            "posTransaccionMetodoPago": arg.metodoDePago,
            "posTransaccionCanal": arg.canal,
            "posTransaccionComprobante": arg.comprobante,
            "usuarioNroDeDocumento": arg.dni !== "" ? Number(arg.dni) : null,
            "merchantCobroEstado": arg.estado
        }
    };

    try {
        const result = await axiosPost('Y', body, arg);

        return result.result
    } catch (err) {
        console.log(err)
    }
}